/** Required upload sizes (px) for Game Content images — exact match, like Theme images. */
export const QUIZ_IMAGE_DIMENSIONS = [443, 336];
export const MATCH_PAIR_IMAGE_DIMENSIONS = [282, 189];

function readImageSize(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(url);
      resolve({ width: img.naturalWidth, height: img.naturalHeight });
    };
    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject(new Error("Could not read the image."));
    };
    img.src = url;
  });
}

/**
 * Resolves to { ok: true } when the image is exactly `width`×`height`,
 * otherwise { ok: false, message } naming the required and actual size.
 */
export async function validateImageDimensions(file, [width, height]) {
  try {
    const size = await readImageSize(file);
    if (size.width !== width || size.height !== height) {
      return {
        ok: false,
        message: `Image must be exactly ${width}×${height} px (this one is ${size.width}×${size.height} px).`,
      };
    }
    return { ok: true };
  } catch (err) {
    return { ok: false, message: err?.message || "Could not read the image." };
  }
}
